import { Rujukan } from "../models";

export const dummyRujukanData: Rujukan[] = [
  {
    id: 1,
    referenceNumber: "9812763450",
    date: "2023-09-30",
    nik: "3171234567890123",
    patientType: "Inpatient",
    patientName: "John Doe",
    doctorName: "Dr. Smith",
    location: "Hospital A",
    referenceLocation: "Hospital B",
    polyName: "Polyclinic X",
    diagnose: "Fever",
    medicine: "Paracetamol",
    actionsTaken: "Rest",
    referenceReason: "Specialized Treatment"
  },
  {
    id: 2,
    referenceNumber: "7645890123",
    date: "2023-09-28",
    nik: "3179876543210987",
    patientType: "Outpatient",
    patientName: "Jane Smith",
    doctorName: "Dr. Johnson",
    location: "Hospital C",
    referenceLocation: "Hospital D",
    polyName: "Polyclinic Y",
    diagnose: "Common Cold",
    medicine: "Ibuprofen",
    actionsTaken: "Prescription",
    referenceReason: "Follow-up Visit"
  },
  {
    id: 3,
    referenceNumber: "2345678901",
    date: "2023-09-25",
    nik: "3178765432109876",
    patientType: "Inpatient",
    patientName: "Alice Johnson",
    doctorName: "Dr. Davis",
    location: "Hospital B",
    referenceLocation: "Hospital A",
    polyName: "Polyclinic Z",
    diagnose: "Broken Arm",
    medicine: "Painkillers",
    actionsTaken: "Splinting",
    referenceReason: "Orthopedic Consultation"
  },
  {
    id: 4,
    referenceNumber: "5432109876",
    date: "2023-09-22",
    nik: "3176543210987654",
    patientType: "Outpatient",
    patientName: "Robert Williams",
    doctorName: "Dr. Brown",
    location: "Hospital D",
    referenceLocation: "Hospital C",
    polyName: "Polyclinic A",
    diagnose: "Allergy",
    medicine: "Antihistamine",
    actionsTaken: "Allergen Avoidance",
    referenceReason: "Allergy Testing"
  },
  {
    id: 5,
    referenceNumber: "1234567890",
    date: "2023-09-08",
    nik: "3173456789012345",
    patientType: "Outpatient",
    patientName: "Michael Lee",
    doctorName: "Dr. Kim",
    location: "Hospital A",
    referenceLocation: "Hospital B",
    polyName: "Polyclinic C",
    diagnose: "Hypertension",
    medicine: "Blood Pressure Medication",
    actionsTaken: "Lifestyle Changes",
    referenceReason: "Cardiology Consultation"
  },
  {
    id: 6,
    referenceNumber: "5678901234",
    date: "2023-09-05",
    nik: "3172345678901234",
    patientType: "Inpatient",
    patientName: "Sophia Chen",
    doctorName: "Dr. Wong",
    location: "Hospital D",
    referenceLocation: "Hospital C",
    polyName: "Polyclinic D",
    diagnose: "Pneumonia",
    medicine: "Antibiotics",
    actionsTaken: "Oxygen Therapy",
    referenceReason: "Respiratory Consultation"
  },
  {
    id: 7,
    referenceNumber: "8901234567",
    date: "2023-09-02",
    nik: "3171234567890123",
    patientType: "Outpatient",
    patientName: "William Taylor",
    doctorName: "Dr. Miller",
    location: "Hospital B",
    referenceLocation: "Hospital A",
    polyName: "Polyclinic E",
    diagnose: "Migraine",
    medicine: "Painkillers",
    actionsTaken: "Rest",
    referenceReason: "Neurology Consultation"
  },
  {
    id: 8,
    referenceNumber: "0987654321",
    date: "2023-08-30",
    nik: "3179876543210987",
    patientType: "Inpatient",
    patientName: "Olivia Clark",
    doctorName: "Dr. Turner",
    location: "Hospital C",
    referenceLocation: "Hospital D",
    polyName: "Polyclinic F",
    diagnose: "Fractured Leg",
    medicine: "Painkillers",
    actionsTaken: "Casting",
    referenceReason: "Orthopedic Consultation"
  },
  {
    id: 9,
    referenceNumber: "7654321098",
    date: "2023-08-28",
    nik: "3178765432109876",
    patientType: "Outpatient",
    patientName: "Daniel Brown",
    doctorName: "Dr. Harris",
    location: "Hospital A",
    referenceLocation: "Hospital B",
    polyName: "Polyclinic G",
    diagnose: "Allergic Rhinitis",
    medicine: "Antihistamine",
    actionsTaken: "Allergen Avoidance",
    referenceReason: "Allergy Testing"
  },
  {
    id: 10,
    referenceNumber: "2345678901",
    date: "2023-08-25",
    nik: "3176543210987654",
    patientType: "Inpatient",
    patientName: "Emma Miller",
    doctorName: "Dr. Carter",
    location: "Hospital D",
    referenceLocation: "Hospital C",
    polyName: "Polyclinic H",
    diagnose: "Diabetes",
    medicine: "Insulin",
    actionsTaken: "Dietary Changes",
    referenceReason: "Endocrinology Consultation"
  }
];
